/* eslint-disable func-style */
import {
    type CursorCollection,
    useCursorPaginationControls,
} from "@smakecloud/smake-use";
import { keepPreviousData } from "@tanstack/vue-query";
import { api } from "~/lib/api";

export type ProductionMethodListSchema =
    typeof api.productionMethods.list.outputType;

export const useProductionProductionStore = defineStore(
    "productionProductionStore",
    () => {
        const searchPageVisited = ref<boolean>(false);
        const disableSearchWatcher = ref<boolean>(false);

        const currentCursor = ref<string>();
        const searchString = ref<string>();
        const perPage = ref<number>(10);

        const { data, error, isError, isFetching, refetch } = useQuery({
            ...api.productionMethods.list.use(
                computed(() => ({
                    cursor: currentCursor.value,
                    filter: {
                        q: searchString.value,
                    },
                    per_page: perPage.value,
                })),
            ),
            placeholderData: keepPreviousData,
        });

        const changeSearch = (search = "") => {
            currentCursor.value = undefined;
            searchString.value = search;
        };

        return {
            changeSearch,
            currentCursor,
            data,
            error,
            isError,
            isFetching,
            searchPageVisited,
            searchString,
            ...useCursorPaginationControls(
                data as Ref<
                    CursorCollection<ProductionMethodListSchema["data"][number]>
                >,
                currentCursor,
            ),
            disableSearchWatcher,
            perPage,
            refetch,
        };
    },
);
